import React from "react";
import { connect } from "react-redux";

import { deleteArticle } from "../../redux/actions/articles";
import styles from "../../styles/Components/Shared/ArticleForm.module.css";

const DeleteForm = ({
  deleteArticle,
  handleClose,
  page,
  searchTerm,
  newestFilter,
  manufacturerFilter,
  pageArticleType,
  article: { selectedArticle },
}) => {
  const handleDelete = (e) => {
    deleteArticle(selectedArticle.article_id, selectedArticle, page, pageArticleType, searchTerm, newestFilter, manufacturerFilter);
    handleClose();
  };
  return (
    <>
      <div className={styles.confirm_modal_container}>
          <p className={styles.confirm_modal_header}>DELETE ARTICLE</p>
          <div>
              <p className={styles.confirm_modal_text}>Are you sure you want to delete {selectedArticle?.title}?</p>
              <p className={styles.confirm_modal_bold}>This cannot be undone.</p>
          </div>
          <div className={styles.confirm_modal_button_container}>
              <button  className={styles.confirm_modal_buttons} onClick={handleClose}>Cancel</button>
              <button  className={styles.confirm_modal_buttons} onClick={handleDelete}>Delete</button>
          </div>
      </div>
      
    </>
  );
};

const mapStateToProps = (state) => ({
  article: state.article,
});

export default connect(mapStateToProps, {
  deleteArticle,
})(DeleteForm);
